import { css } from '@emotion/react';

const setEnergyStyles = {
    container: css({
        position: 'relative',
    }),
    columnWrapper: css({
        display: 'flex',
        flexWrap: 'wrap',
        height: '160px',
        marginTop: '25px',
        marginBottom: '16px',
    }),
    column: css({
        display: 'flex',
        flexGrow: 1,
        flexBasis: 0,
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '20px',
    }),
    infoBlock: css({
        display: 'flex',
        flexBasis: 0,
        flexDirection: 'column',
    }),
    infoBlockTitle: css({
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '14px',
        color: '#000000',
        opacity: 0.5,
    }),
    infoBlockValue: css({
        display: 'flex',
        fontWeight: 700,
        fontSize: '16px',
        lineHeight: '18px',
        color: '#101010',
        alignItems: 'flex-end',
    }),
    infoBlockValueSymbol: css({
        fontWeight: 700,
        fontSize: '8px',
        lineHeight: '12px',
        color: '#101010',
        paddingLeft: '5px',
        display: 'flex',
    }),
    battery: css({
        width: '82px',
        height: '160px',
        border: '2px solid #000000',
        borderRadius: '4px',
        position: 'relative',
        flexDirection: 'column-reverse',
        display: 'flex',

        ':before': {
            content: '""',
            position: 'absolute',
            boxShadow: '0px 3px 3px rgb(0 0 0 / 16%)',
            borderRadius: '10px 10px 5px 5px',
            width: '26px',
            height: '6px',
            backgroundColor: '#101010',
            top: '-10px',
            left: 0,
            right: 0,
            margin: '0 auto',
        },
    }),
    batteryEnergy: css({
        background: 'linear-gradient(90deg, #0A39FF 0%, #6497E5 100%)',
    }),
    batteryEnergyValue: css({
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: '50%',
        transform: 'translateY(50%)',
        display: 'flex',
        justifyContent: 'center',
    }),
    inputEnergy: css({
        background: 'transparent',
        textAlign: 'center',
        fontWeight: 500,
        fontSize: '16px',
        lineHeight: '100%',
        color: '#000000',
        width: '95%',
        border: 'none',
        ':focus': {
            outline: 'none !important',
            border: '2px solid black',
            borderRadius: '4px',
        },
        '::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
        '::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
        MozAppearance: 'textfield',
    }),
    batteryEnergyValueLabel: css({
        fontWeight: 600,
        fontSize: '15px',
        color: '#000000',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-end',
        cursor: 'pointer',
        padding: ' 0 5px',
        justifyContent: 'center',
        flexWrap: 'wrap',
    }),
    batteryEnergyValueSymbol: css({
        fontWeight: 700,
        fontSize: '10px',
        lineHeight: '10px',
        color: '#000000',
        textAlign: 'center',
        marginBottom: 2,
    }),
    actionWrapper: css({
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        marginBottom: '12px',
        width: '100%',
        button: {
            width: '100%',
        },
    }),
    maxEnergy: css({
        color: '#FFFFFF',
        fontSize: '15px',
        lineHeight: '16px',
        letterSpacing: '-0.12px',
        border: 'solid 1px #000000',
        backgroundColor: '#000000',
        padding: '12px 4px',
        boxShadow: 'none',
        borderRadius: '9px',
        cursor: 'pointer',
    }),
    nextButton: css({
        width: '100%',
    }),
    blockingFeeBlock: css({
        marginBottom: '8px',
        display: 'flex',
        justifyContent: 'space-between',
    }),
    blockingFee: css({
        fontSize: 12,
        fontWeight: 500,
        color: '#000000',
    }),
    blockingFeeValue: css({
        fontSize: 12,
        fontWeight: 700,
        color: '#000000',
    }),
    energyUnits: css({
        fontSize: 10,
        fontWeight: 700,
        lineHeight: '16px',
        paddingLeft: 5,
    }),
};

export default setEnergyStyles;
